import { IconsMockApi } from 'app/mock-api/ui/icons/api';
import { UserMockApi } from 'app/mock-api/common/user/api';
import { NavigationMockApi } from 'app/mock-api/common/navigation/api';
import { ChatMockApi } from 'app/mock-api/apps/chat/api';


export const mockApiServices = [
    IconsMockApi,
    UserMockApi,
    NavigationMockApi,
    ChatMockApi
];


